module.exports = __webpack_public_path__ + "static/media/profile_janos.cd01e2af.JPG";